import styled from 'styled-components'
import Card from '@mui/material/Card'

export const Container = styled(Card)`
    padding: 20px;
    max-width: 1200px;
    max-height: 2500px;
    color: #000000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #f5f5f5;
`

export const FormContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    min-width: 1000px;
    margin: 0;
    padding: 0;
    gap: 20px;
    align-items: flex-start;
    min-height: 400px;
`

export const Column = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
`
